import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import profilePic from '../Images/ProfilePicture.jpg';

const About = () => {
  return (
    <Container>
      <div className="About" id="About">
        <h2 className="header-clr">About</h2>
        <div className="divider"></div>
        <br />
        <p>
          Full-Stack Developer specializing in building scalable, high-performance web applications across the MERN stack and Java Spring Boot ecosystems. Experienced in engineering secure microservices, optimizing database queries, and designing responsive frontend interfaces.
        </p>
      </div>
      <div className="AboutMain">
        <div className="picture">
          <Row>
            <Col xs={12}>
              <Image className="dp-pic" src={profilePic} rounded alt="Babu Balaji V" />
            </Col>
          </Row>
        </div>
        <div className="bio">
          <h3>Full Stack Software Engineer</h3>
          <p className="fw-light">
            Full-Stack Developer with 2 years of hands-on experience designing and scaling high-performance web applications across MERN and Java Spring Boot ecosystems. Proven expertise in microservices, RESTful API engineering, Redis caching, and responsive frontend optimization. Experienced in delivering scalable, low-latency client solutions within Agile frameworks.
          </p>
          <div className="main-bio shadow-sm p-3 mb-4 bg-body rounded">
            <div className="arrow-clr left-bio fs-6">
              <p><i className="bi bi-chevron-right"></i> <b>Current Role:</b> System Engineer @ TCS</p>
              <p><i className="bi bi-chevron-right"></i> <b>Education:</b> B.Tech in Computer Science & Engineering</p>
            <p><i className="bi bi-chevron-right"></i> <b>Email:</b> <a style={{ color: 'black' }} href="mailto:babu.balajijr@gmail.com">babu.balajijr@gmail.com</a></p>
              <p><i className="bi bi-chevron-right"></i> <b>Location:</b> Bengaluru, India</p>
              <p>
                <i className="bi bi-chevron-right"></i> <b>Profiles:</b>{' '}
                <a href="https://github.com/BABU-BALAJI-V" target="_blank" rel="noreferrer"><b>GitHub</b></a> |{' '}
                <a href="https://leetcode.com/u/3Y6CjUTiSb/" target="_blank" rel="noreferrer"><b>LeetCode</b></a> |{' '}
                <a href="https://www.linkedin.com/in/babubalajiv/" target="_blank" rel="noreferrer"><b>LinkedIn</b></a>
              </p>
            </div>
          </div>
          <p className="bio-ptag">
            I focus on engineering scalable, end-to-end full-stack systems from database schema optimization and API performance tuning to modular, accessible frontend components.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default About;